import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9867f892"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bar-labels" }
const _hoisted_2 = {
  key: 0,
  class: "label death-label"
}
const _hoisted_3 = {
  key: 1,
  class: "label age-label"
}
const _hoisted_4 = {
  key: 2,
  class: "label birth-label"
}


export default /*#__PURE__*/_defineComponent({
  __name: 'LifespanBar',
  props: {
    birthYear: {},
    deathYear: {},
    age: {},
    living: { type: Boolean },
    layout: { default: 'full' }
  },
  emits: ["click"],
  setup(__props: any, { emit }) {

const props = __props;





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["lifespan-bar", 'bar-' + props.layout]),
    onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('click', $event)))
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["bar", { 'unknown-death': !props.deathYear && !props.living }])
    }, null, 2),
    _createElementVNode("div", _hoisted_1, [
      (props.deathYear)
        ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(props.deathYear), 1))
        : _createCommentVNode("", true),
      (props.age)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(props.age), 1))
        : _createCommentVNode("", true),
      (props.birthYear)
        ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(props.birthYear), 1))
        : _createCommentVNode("", true)
    ])
  ], 2))
}
}

})